import React, { useMemo } from "react";
import {
  useTheme,
  List
} from "@mui/material";
import { ChatlistItem } from "@/components/broadcast";
import { IBroadcastChatListItem } from "@/utils/zod/broadcastChatSchema";
import { useList } from "@refinedev/core";

export const ChatList: React.FC<{
  onChatSelect: (chatId: string) => void;
  selectedChatIds: string[];
  allowCheckbox?: boolean;
}> = ({ onChatSelect, selectedChatIds, allowCheckbox = false }) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

    const { data: broadcasts } = useList<IBroadcastChatListItem>({
        resource: "rooms/broadcasts",
    });
  
  // Sort broadcasts by last message time
  const sortedBroadcasts = useMemo(() => {
    return [...(broadcasts?.data || [])].sort((a, b) => {
      const timeA = a.last_message?.server_received_at ? new Date(a.last_message.server_received_at).getTime() : 0;
      const timeB = b.last_message?.server_received_at ? new Date(b.last_message.server_received_at).getTime() : 0;
      return timeB - timeA; // Most recent first
    });
  }, [broadcasts?.data]);

  return (
    <List
        sx={{
          backgroundColor: isDarkMode ? theme.palette.grey[900] : theme.palette.grey[50],
          height: "100%",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          padding: 0,
        }}
    >
        <List sx={{ width: "100%", bgcolor: "background.paper", padding: 0, height: '100%' }} >
        {sortedBroadcasts.length > 0 ? (
            sortedBroadcasts.map((broadcast) => (
                <ChatlistItem 
                    key={broadcast.id}
                    chat={broadcast}
                    isSelected={selectedChatIds?.includes(broadcast.id)}
                    onSelect={onChatSelect}
                    allowCheckbox={allowCheckbox}
                />
            ))
        ) : (
            <div style={{ padding: '16px', textAlign: 'center' }}>
                No broadcasts available
            </div>
        )}
      </List>
    </List>
  );
};